import { serviceModel, serviceBillingModel } from "../../models";
import { AdvancedSetting } from "./ServiceAdvancedSettings.types";
export const isSettingActive = _ref => {
  var _service$integrations, _service$integrations2;
  let {
    type,
    service
  } = _ref;
  switch (type) {
    case AdvancedSetting.Pause:
      return serviceModel.isPaused(service);
    case AdvancedSetting.BillOnApproval:
      return !serviceModel.isSkipBillingOnAcceptance(service);
    case AdvancedSetting.Prorate:
      return serviceModel.isProrated(service);
    case AdvancedSetting.Optional:
      return service.participation.type === 'optional';
    case AdvancedSetting.LimitCharges:
      return serviceModel.maxChargesEnabled(service);
    case AdvancedSetting.AutoPriceIncrease:
      {
        var _serviceChanges$cost;
        if (serviceModel.priceIncrease(service).exists()) {
          return true;
        }
        const serviceChanges = serviceModel.changes(service);
        if (serviceChanges !== null && serviceChanges !== void 0 && (_serviceChanges$cost = serviceChanges.cost) !== null && _serviceChanges$cost !== void 0 && _serviceChanges$cost.priceIncrease) {
          return serviceChanges.cost.priceIncrease.exists();
        }
        return false;
      }
    case AdvancedSetting.QboClasses:
      return serviceModel.integratedClassId(service) != null;
    case AdvancedSetting.FinancialCents:
      return !!((_service$integrations = service.integrations.financialCentsIntegration()) !== null && _service$integrations !== void 0 && _service$integrations.hasAssignedTeamMembers());
    case AdvancedSetting.Karbon:
      return !!((_service$integrations2 = service.integrations.karbonIntegration()) !== null && _service$integrations2 !== void 0 && _service$integrations2.hasAssignedTeamMembers());
    case AdvancedSetting.LimitedTimeDiscountOffer:
      return !!serviceModel.limitedTimeDiscountOffer(service);
    case AdvancedSetting.LimitedTimeDiscountOfferForAgreement:
      {
        var _serviceModel$discoun, _serviceChanges$cost2;
        const discount = service.cost.discount;
        if (discount && (_serviceModel$discoun = serviceModel.discount(service)) !== null && _serviceModel$discoun !== void 0 && (_serviceModel$discoun = _serviceModel$discoun.expiration()) !== null && _serviceModel$discoun !== void 0 && _serviceModel$discoun.hasExpiration()) {
          return true;
        }
        const serviceChanges = serviceModel.changes(service);
        if (serviceChanges !== null && serviceChanges !== void 0 && (_serviceChanges$cost2 = serviceChanges.cost) !== null && _serviceChanges$cost2 !== void 0 && _serviceChanges$cost2.discount) {
          var _serviceModel$discoun2;
          return !!((_serviceModel$discoun2 = serviceModel.discount({
            cost: serviceChanges.cost
          })) !== null && _serviceModel$discoun2 !== void 0 && (_serviceModel$discoun2 = _serviceModel$discoun2.expiration()) !== null && _serviceModel$discoun2 !== void 0 && _serviceModel$discoun2.hasExpiration());
        }
        return false;
      }
    case AdvancedSetting.PreapprovedAmount:
      {
        if (serviceModel.hasPreapprovedAmount(service)) {
          return true;
        }
        const serviceChanges = serviceModel.changes(service);
        if (serviceChanges !== null && serviceChanges !== void 0 && serviceChanges.cost) {
          return serviceModel.hasPreapprovedAmount({
            cost: serviceChanges.cost
          });
        }
        return false;
      }
    case AdvancedSetting.StartAutomaticBillingAt:
      {
        if (serviceModel.isPaused(service)) {
          return true;
        }
        if (serviceModel.startBillingAt(service)) {
          return true;
        }
        if (serviceBillingModel.isOngoing(service.billing) && serviceModel.isBilledUpfront(service) && !serviceModel.isSkipBillingOnAcceptance(service)) {
          return true;
        }
        return false;
      }
    default:
      return false;
  }
};